import React from 'react';
import { Phone, Mail, Building, FileText } from 'lucide-react';
import './ContactPage.scss';

const ContactPage: React.FC = () => {
  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="hero-content">
          <h1>Susisiekite su mumis</h1>
          <p>Turite klausimų? Mielai į juos atsakysime!</p>
        </div>
      </section>

      {/* Contact Info Section */}
      <section className="contact-info-section">
        <div className="contact-container">
          <div className="info-content">
            {/* Company Details */}
            <div className="info-block company-details">
              <h2>
                <Building size={20} />
                Įmonės rekvizitai
              </h2>
              <div className="details-grid">
                <div className="details-column">
                  <div className="detail-row">
                    <span className="label">Įmonė</span>
                    <span className="value">UAB "CV Gidas Lt"</span>
                  </div>
                  <div className="detail-row">
                    <span className="label">Adresas</span>
                    <span className="value">Rasytės g. 34, Kaunas</span>
                  </div>
                  <div className="detail-row">
                    <span className="label">Telefonas</span>
                    <span className="value">
                      <a href="tel:+37037234866">+370 37 23486</a>
                      <br />
                      <a href="tel:+37067256489">+370 672 56489</a>
                    </span>
                  </div>
                  <div className="detail-row">
                    <span className="label">El. paštas</span>
                    <span className="value">
                      <a href="mailto:info@cvgidas.lt">info@cvgidas.lt</a>
                    </span>
                  </div>
                </div>
                <div className="details-column">
                  <div className="detail-row">
                    <span className="label">Faksas</span>
                    <span className="value">+370 37 525846</span>
                  </div>
                  <div className="detail-row">
                    <span className="label">Kodas</span>
                    <span className="value">34619698</span>
                  </div>
                  <div className="detail-row">
                    <span className="label">PVM kodas</span>
                    <span className="value">LT100005565486</span>
                  </div>
                  <div className="detail-row">
                    <span className="label">Bankas</span>
                    <span className="value">DNB bankas, AB</span>
                  </div>
                  <div className="detail-row">
                    <span className="label">Sąskaita</span>
                    <span className="value">LT977300010126887890</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Support Sections */}
            <div className="support-sections">
              <div className="support-block">
                <h3>
                  <Phone size={18} />
                  Pagalba ieškantiems darbo
                </h3>
                <div className="support-info">
                  <div className="support-row">
                    <span className="label">Tel.:</span>
                    <a href="tel:+37037256956">+370 37 256956</a>
                  </div>
                  <div className="support-row">
                    <span className="label">El. paštas:</span>
                    <a href="mailto:support@cvgidas.lt">support@cvgidas.lt</a>
                  </div>
                </div>
              </div>

              <div className="support-block">
                <h3>
                  <FileText size={18} />
                  Pagalba įmonėms
                </h3>
                <div className="support-info">
                  <div className="support-row">
                    <span className="label">Tel.:</span>
                    <a href="tel:+37037256956">+370 37 256956</a>
                  </div>
                  <div className="support-row">
                    <span className="label">El. paštas:</span>
                    <a href="mailto:support@cvgidas.lt">support@cvgidas.lt</a>
                  </div>
                </div>
              </div>
            </div>

            {/* Advertising */}
            <div className="advertising-block">
              <h3>
                <Mail size={18} />
                Reklamos klausimais kreipkitės
              </h3>
              <div className="support-info">
                <div className="support-row">
                  <span className="label">Tel.:</span>
                  <a href="tel:+37037274049">+370 37 274049</a>
                </div>
                <div className="support-row">
                  <span className="label">El. paštas:</span>
                  <a href="mailto:reklama@cvgidas.lt">reklama@cvgidas.lt</a>
                </div>
              </div>
            </div>
          </div>

          {/* Map */}
          <div className="map-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2294.5!2d23.9!3d54.9!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNTTCsDU0JzAwLjAiTiAyM8KwNTQnMDAuMCJF!5e0!3m2!1sen!2slt!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="CV Gidas location"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;

